import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 pt-20 px-4 py-12">
      <div className="container mx-auto max-w-4xl">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-blue-400 hover:bg-blue-500/10"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Back
        </Button>

        <div className="bg-white/5 backdrop-blur-lg rounded-xl p-6 md:p-8 border border-white/10">
          <h1 className="text-3xl font-bold text-white mb-6">Privacy Policy</h1>


          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Information We Collect</h2>
              <ul className="list-disc pl-5 space-y-2">
                <li><span className="font-medium">Personal Information:</span> Name, Email, Phone Number, PAN, Date of Birth, etc.</li>
                <li><span className="font-medium">Financial Information:</span> Credit-related data (if you consent).</li>
                <li><span className="font-medium">Technical Data:</span> IP address, browser type, cookies, and usage data.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. How We Use Your Information</h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>To provide financial services and tools.</li>
                <li>To verify your identity and process credit score requests.</li>
                <li>To improve our Website and customer experience.</li>
                <li>To comply with legal and regulatory requirements.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. Sharing of Information</h2>
              <p className="mb-3">We may share your information with:</p>
              <ul className="list-disc pl-5 space-y-2 mb-3">
                <li>Credit Bureaus (like CIBIL) and fintech partners (only with your consent).</li>
                <li>Service Providers who help us operate our Website.</li>
                <li>Regulatory Authorities when legally required.</li>
              </ul>
              <p className="font-medium">We never sell your personal information to third parties.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Data Security</h2>
              <p>We use industry-standard security measures (encryption, secure servers, limited access) to protect your data. However, no online transmission is 100% secure.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Cookies & Tracking</h2>
              <p>We may use cookies to enhance your browsing experience. You can disable cookies in your browser settings.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Your Rights</h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>Access and update your information.</li>
                <li>Withdraw consent for data processing.</li>
                <li>Request deletion of your data (subject to legal requirements).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Third-Party Links</h2>
              <p>Our Website may contain links to third-party sites. We are not responsible for their privacy practices.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. Changes to Policy</h2>
              <p>We may update this Privacy Policy periodically. Updates will be posted on this page.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">9. Contact Us</h2>
              <p className="mb-2">For questions or concerns about this Privacy Policy, contact us at:</p>
              <ul className="space-y-1">
                <li><span className="font-medium">Email:</span> info@whitepearlfinance.com</li>
                <li><span className="font-medium">Phone:</span> +91-9324471736</li>
                <li className="max-w-md">
                  <span className="font-medium">Address:</span> White Pearl Finance, Unit 10, Ganjawala Apt, Building No. 3,
                  Near by Petrol Pump, Borivali (W), Mumbai - 400092.
                </li>
              </ul>
            </section>

            <div className="bg-yellow-500/10 border-l-4 border-yellow-500 p-4 mt-8">
              <h3 className="font-semibold text-yellow-400 mb-2">⚠️ Important:</h3>
              <p className="text-yellow-300">
                Since you're handling financial and possibly credit data, you should also:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Add a Consent Checkbox before users check their CIBIL score.</li>
                <li>Mention compliance with RBI & Data Privacy laws (like PDPB in India).</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
